import React from 'react';
import { 
  FaBrain,
  FaBaby,
  FaStar,
  FaCheckCircle,
  FaHospital,
  FaUserMd,
  FaStethoscope,
  FaHeartbeat
} from 'react-icons/fa';
import '../style.css';

const RocklandDetails = () => {
  const images = [
    {
      id: 1,
      url: 'https://static.wixstatic.com/media/7657a7_68a562b31c144cb6917e3f67155eea36~mv2.jpg/v1/fill/w_280,h_280,q_90/7657a7_68a562b31c144cb6917e3f67155eea36~mv2.jpg',
      title: ' Operation Theater',
      icon: <FaHospital />
    },
    {
      id: 2,
      url: 'https://tse4.mm.bing.net/th/id/OIP.16x1Nj1a00topSfTgSXpVQHaKT?pid=ImgDet&w=474&h=659&rs=1&o=7&rm=3',
      title: 'Expert Medical Team',
      icon: <FaUserMd />
    },
    {
      id: 3,
      url: 'https://img.freepik.com/premium-photo/modern-minimalist-hospital-medical-room-with-advanced-medical-equipment_477229-306.jpg',
      title: 'Modern Equipment',
      icon: <FaStethoscope />
    },
    {
      id: 4,
      url: 'image0.png',
    }
  ];

  return (
    <div className="rockland-clinic-images">
      {/* Left Side - Text Content (Same as before) */}
      <div className="clinic-text-side">
        <div className="clinic-header">
          <div className="header-icons">
            <FaBrain className="icon-brain" />
            <FaBaby className="icon-baby" />
          </div>
          <h1>Rockland Neuro & Mother Child Health Center</h1>
          <div className="header-line"></div>
        </div>
        
        <div className="clinic-content">
          <p className="clinic-description">
            At <strong>Rockland Neuro & Mother Child Health Centre</strong>, we are dedicated to 
            providing exceptional healthcare services in the fields of neurology, neurosurgery, 
            infertility, and maternal health. With a team of highly skilled neurosurgeons, neuro 
            specialists, and top infertility doctors in Varanasi, we ensure advanced medical care 
            tailored to each patient's needs.
          </p>
          
          <p className="clinic-description">
            <strong>Rockland Neuro & Mother Child Health Centre</strong> offers expert care from 
            the best neurosurgeons, neuro specialists, and top infertility doctors in Varanasi. 
            We provide advanced treatment for neurological disorders, infertility, and maternal 
            health, ensuring personalized care with utmost confidentiality.
          </p>
          
          <div className="key-points">
            <div className="point-item">
              <FaCheckCircle className="check-icon" />
              <span>Advanced Neurology & Neurosurgery</span>
            </div>
            <div className="point-item">
              <FaCheckCircle className="check-icon" />
              <span>Expert Infertility Treatment</span>
            </div>
            <div className="point-item">
              <FaCheckCircle className="check-icon" />
              <span>Comprehensive Maternal Healthcare</span>
            </div>
            <div className="point-item">
              <FaCheckCircle className="check-icon" />
              <span>Personalized Patient Care</span>
            </div>
          </div>
          
          <div className="stats-line">
            <div className="stat">
              <span className="stat-number">15+</span>
              <span className="stat-label">Years</span>
            </div>
            <div className="stat">
              <span className="stat-number">50K+</span>
              <span className="stat-label">Patients</span>
            </div>
            <div className="stat">
              <span className="stat-number">98%</span>
              <span className="stat-label">Success</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Care</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - 4 Images Grid */}
      <div className="clinic-images-side">
        <div className="images-grid">
          {images.map((image) => (
            <div key={image.id} className="image-item">
              <div 
                className="grid-image"
                style={{ backgroundImage: `url('${image.url}')` }}
              >
                <div className="image-overlay"></div>
                <div className="image-content">
                  <div className="image-icon">{image.icon}</div>
                  <h4>{image.title}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Bottom Badge */}
        <div className="images-badge">
          <FaStar />
          <span>Excellence in Healthcare </span>
        </div>
      </div>
    </div>
  );
};

export default RocklandDetails;